import { render, staticRenderFns } from "./SizeTextarea.vue?vue&type=template&id=242fa9f2"
import script from "./SizeTextarea.vue?vue&type=script&lang=js"
export * from "./SizeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports